import axios from "axios";

export default function ProfilePasswordService(formData) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/api/v2/password",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
